// Espejo de los catálogos cerrados de `app/core/validation.py`.

export const CONTRACT_TYPES = [
  'indefinido',
  'fijo',
  'obra_labor',
  'aprendizaje_sena',
  'prestacion_servicios',
  'otro',
] as const

export const JORNADA_TYPES = ['diurna', 'nocturna', 'mixta', 'rotativa'] as const

export const NIVEL_EDUCATIVO = [
  'ninguno',
  'primaria',
  'secundaria',
  'tecnico',
  'tecnologo',
  'universitario',
  'posgrado',
] as const

export const GENERO = ['femenino', 'masculino', 'otro', 'prefiero_no_decir'] as const

export const EPS_OPTIONS = [
  'Nueva EPS',
  'Sura',
  'Sanitas',
  'Salud Total',
  'Compensar',
  'Famisanar',
  'Coosalud',
  'Mutual Ser',
  'SOS',
  'Aliansalud',
  'Cajacopi',
  'Emssanar',
  'Asmet Salud',
  'Savia Salud',
] as const

export const AFP_OPTIONS = ['Porvenir', 'Protección', 'Colfondos', 'Skandia', 'Colpensiones'] as const

// Mismo catálogo que la ARL de empresa y sede (`businesses.py`). En la ficha es la ARL propia del
// contratista de prestación de servicios; al resto lo cubre la de la empresa.
export const ARL_OPTIONS = [
  'Positiva',
  'Sura',
  'Colmena',
  'Bolívar',
  'AXA Colpatria',
  'La Equidad',
  'Liberty',
  'Mapfre',
  'Previsora',
  'Alfa',
] as const
